import { Amplify } from 'aws-amplify';
import { record } from 'aws-amplify/analytics/kinesis';
import { fetchAuthSession } from 'aws-amplify/auth';
//import awsconfig from '../../aws-exports';
import moment from "moment";
import {
    BLANK,
    DATE_TIME_SUFFIX,
    MAX_END_DATE
} from "../pages/CAMPAIGN/ms/common/CommonConst";
import {Option, OptionBool, options_pref, valueToOptionNull} from "./Apollo_styles";

export type LogData = {
    eventDate: string, // イベント日時 “YYYY/MM/DD HH:MM:SS“ 形式
    logType: string, // ログ種別 実行：execute, 結果：result
    result: string, // 実行結果 成功 / 失敗 ※実行時は空文字
    userID: number,　// ユーザID
    userName: string,　// Apolloユーザ名 姓 + 半角スペース + ユーザ名
    accessToken: string, // APIアクセス用トークン
    accountGroupID: number, // アカウントグループID
    accountGroupName: string, // アカウントグループ名
    accountID: number, // 広告主アカウントID
    accountName: string, // 広告主アカウント名
    campaignID: string, // キャンペーンID
    campaignName: string, // キャンペーン名
    adGroupID: string, // 広告グループID
    adGroupName: string, // 広告グループ名
    menu: string, // メニュー パフォーマンス広告 / メール広告
    displayName: string, // 操作画面名称 〇〇画面
    category: string, // 操作対象 キャンペーン / セグメント etc...
    actionType: string, // アクション 参照 / 作成 / 更新 / 削除 / アップロード
    targetID: string, // 操作を行うデータのID 実行時は空文字
    targetName: string, // 操作を行うデータの名称 実行時は空文字
    itemList: ItemList[],
}

export type ItemList = {
    key: string, // 項目名
    beforeValue: string, // 変更前の値
    afterValue: string, // 変更後の値
}

const env = process.env.REACT_APP_ENV
const apolloStreamName = process.env.REACT_APP_LOG_STREAM

// v4 で自動的に入っていた "partition-<identityId>" を再現するためのキャッシュ
let cachedPartitionKey: string | null = null;
let partitionKeyPromise: Promise<string> | null = null;

const getPartitionKeyFallback = (inputData: LogData) =>
    `partition-${String(inputData.userID ?? "0")}`;

const getPartitionKey = (inputData: LogData): Promise<string> => {
    if (cachedPartitionKey) return Promise.resolve(cachedPartitionKey);
    if (partitionKeyPromise) return partitionKeyPromise;    
    partitionKeyPromise = fetchAuthSession()
      .then((session) => {
        // identityId は環境によって型定義に出ないことがあるので any で参照
        const identityId = (session as any).identityId as string | undefined;
        cachedPartitionKey = identityId
          ? `partition-${identityId}`
          : getPartitionKeyFallback(inputData);
        return cachedPartitionKey;
      })
      .catch(() => {
        cachedPartitionKey = getPartitionKeyFallback(inputData);
        return cachedPartitionKey;
      })
      .finally(() => {
        partitionKeyPromise = null;
      });   
    return partitionKeyPromise;
}

if (env == "prod") {
    Amplify.configure({
        Auth: {
            Cognito: {
                identityPoolId: "ap-northeast-1:1363f014-ca93-438a-bfe7-ce64d628727b",
                allowGuestAccess: true,
            }
        },
        Analytics: {
            Kinesis: {
                region: "ap-northeast-1",
                bufferSize: 1000,
                flushSize: 100,
                flushInterval: 5000,
                resendLimit: 5,
            }
        }
    });
} else {
    Amplify.configure({
        Auth: {
            Cognito: {
                identityPoolId: "ap-northeast-1:266de904-41d9-4775-8f15-64b43c459227",
                allowGuestAccess: true,
            }
        },
        Analytics: {
            Kinesis: {
                region: "ap-northeast-1",
                bufferSize: 1000,
                flushSize: 100,
                flushInterval: 5000,
                resendLimit: 5,
            }
        }
    });
}


export const ApolloEventRecord = (inputData: LogData) => {
    if (!apolloStreamName) {
        return;
    }

    const bytes = new TextEncoder().encode(`${JSON.stringify(inputData)}\n`);
    console.log(bytes);
    void getPartitionKey(inputData).then((pk) => {
        record({
            streamName: apolloStreamName,
            data: bytes,
            partitionKey: pk,
        });
    });
}

const FULL_COMMA = "、"

export const createLogDate = (
    apolloContex: any,
    menu: string,
    category: string,
    actionType: string,
    displayName: string,
    items: ItemList[],
    campaignId?: string,
    campaignName?: string,
    adGroupId?: string,
    adGroupName?: string,
) => {

    const retObj: LogData = {
        eventDate: moment().format("YYYY-MM-DD HH:mm:ss"),
        logType: BLANK,
        result: BLANK,
        userID: apolloContex.userprofile.userId,
        userName: apolloContex.userprofile.userName,
        accessToken: apolloContex.accesstoken,
        accountGroupID: apolloContex.current.accountGroupId,
        accountGroupName: apolloContex.current.accountGroupName,
        accountID: apolloContex.current.accountId,
        accountName: apolloContex.current.accountName,
        campaignID: campaignId ?? BLANK,
        campaignName: campaignName ?? BLANK,
        adGroupID: adGroupId ?? BLANK,
        adGroupName: adGroupName ?? BLANK,
        menu: menu,
        displayName: displayName,
        category: category,
        actionType: actionType,
        targetID: BLANK,
        targetName: BLANK,
        itemList: items,
    }

    return retObj
}

export const createUserLogItemListFromNumber = (
    label: string,
    itemName: string,
    beforeInfo: any | null,
    afterInfo: any,
) => {
    const retObj: ItemList = {
        key: label,
        beforeValue: beforeInfo?.[itemName]?.toString() ?? BLANK,
        afterValue: afterInfo?.[itemName]?.toString() ?? BLANK,
    }
    return retObj
}

export const createUserLogItemListFromNumberWitZeroToBlank = (
    label: string,
    itemName: string,
    beforeInfo: any | null,
    afterInfo: any,
) => {
    const retObj: ItemList = {
        key: label,
        beforeValue: beforeInfo ? beforeInfo?.[itemName] ? beforeInfo?.[itemName] == 0 ? BLANK : beforeInfo?.[itemName].toString() : BLANK : BLANK,
        afterValue: afterInfo ? afterInfo?.[itemName] ? afterInfo?.[itemName] == 0 ? BLANK : afterInfo?.[itemName].toString() : BLANK : BLANK,
    }
    return retObj
}

export const createUserLogItemListFromRadioValues = (
    label: string,
    itemName: string,
    beforeInfo: any | null,
    afterInfo: any,
    option: any,
) => {
    const beforeLabel = option.filter((elem: any) => {
        return beforeInfo?.[itemName] === elem.value
    })?.[0]?.label ?? BLANK
    const afterLabel = option.filter((elem: any) => {
        return afterInfo?.[itemName] === elem.value
    })?.[0]?.label ?? BLANK

    const retObj: ItemList = {
        key: label,
        beforeValue: beforeLabel,
        afterValue: afterLabel,
    }
    return retObj
}

export const createUserLogItemListFromOptionValue = (
    label: string,
    itemName: string,
    beforeInfo: any | null,
    afterInfo: any,
    option: any,
) => {

    const beforeLabel = option.filter((elem: any) => {
        return (itemName === BLANK　?  beforeInfo : beforeInfo?.[itemName]) === elem.value
    })?.[0]?.label ?? BLANK
    const afterLabel = option.filter((elem: any) => {
        return (itemName  === BLANK ?  afterInfo : afterInfo?.[itemName]) === elem.value
    })?.[0]?.label ?? BLANK

    const retObj: ItemList = {
        key: label,
        beforeValue: beforeLabel,
        afterValue: afterLabel,
    }
    return retObj
}

export const createUserLogItemListFromCheck = (
    label: string,
    itemName: string,
    beforeInfo: any | null,
    afterInfo: any,
) => {

    const retObj: ItemList = {
        key: label,
        beforeValue: beforeInfo ? beforeInfo?.[itemName]  ? "チェックあり" : "チェックなし" : BLANK,
        afterValue: afterInfo?.[itemName]  ? "チェックあり" : "チェックなし"
    }
    return retObj
}

export const createUserLogItemListFromCheck2 = (
    label: string,
    itemName: string,
    beforeInfo: any | null,
    afterInfo: any,
) => {

    const retObj: ItemList = {
        key: label,
        beforeValue: beforeInfo ? beforeInfo?.[itemName]  ? "設定あり" : "設定なし" : BLANK,
        afterValue: afterInfo?.[itemName]  ? "設定あり": "設定なし"
    }
    return retObj
}

export const createUserLogItemListFromDomainSetting = (
    label: string,
    itemName: string,
    beforeInfo: any | null,
    afterInfo: any,
) => {

    const NONE = "設定なし"
    const EXCLUDE = "除外設定"
    const INCLUDE = "指定設定"

    const retObj: ItemList = {
        key: label,
        beforeValue: beforeInfo ? beforeInfo?.[itemName] ? beforeInfo?.[itemName] == 1 ? EXCLUDE : beforeInfo?.[itemName] == 2 ? INCLUDE : NONE  : NONE : NONE,
        afterValue: afterInfo ? afterInfo?.[itemName] ? afterInfo?.[itemName] == 1 ? EXCLUDE : afterInfo?.[itemName] == 2 ? INCLUDE : NONE  : NONE : NONE,    }
    return retObj
}

const getDateLabel = (inputDate : string, format : string) => {
    let retValue = BLANK
    retValue = (inputDate != BLANK &&(moment(inputDate?.replace(DATE_TIME_SUFFIX, BLANK)).format(format) === moment(MAX_END_DATE).format(format))) ?
        "継続的配信" : inputDate && moment(inputDate).format(format)
    return retValue;
}

export const createUserLogItemListFromDate = (
    label: string,
    itemName: string,
    beforeInfo: any | null,
    afterInfo: any,
    format: string,
) => {
    const beforeLabel = beforeInfo?.[itemName] ?? BLANK
    let afterLabel = afterInfo?.[itemName] ?? BLANK

    const retObj: ItemList = {
        key: label,
        beforeValue: getDateLabel(beforeLabel.replace(DATE_TIME_SUFFIX, BLANK), format),
        afterValue: getDateLabel(afterLabel.replace(DATE_TIME_SUFFIX, BLANK), format),
    }
    return retObj
}

export const createUserLogItemListFromString = (
    label: string,
    itemName: string,
    beforeInfo: any | null,
    afterInfo: any,
) => {
    const retObj: ItemList = {
        key: label,
        beforeValue: beforeInfo?.[itemName] ?? BLANK,
        afterValue: afterInfo?.[itemName] ?? BLANK,
    }
    return retObj
}

export const SCHEDULES_WEEKS_MS = ["日曜日", "月曜日", "火曜日", "水曜日", "木曜日", "金曜日", "土曜日"]

export const createUserLogItemListFromSchedules = (
    label: string,
    itemName: string,
    beforeInfo: any | null,
    afterInfo: any,
    weeks: string[],
) => {
    const retObj: ItemList = {
        key: label,
        beforeValue: beforeInfo?.[itemName] ? transferSchedulesToLabel(beforeInfo[itemName], weeks) : BLANK,
        afterValue: afterInfo?.[itemName] ? transferSchedulesToLabel(afterInfo[itemName], weeks) : BLANK,
    }
    return retObj
}

const transferSchedulesToLabel = (
    inputLabel: string,
    weeks: string[]
) => {
    return "[" + JSON.parse(inputLabel).map((value: number[], index1: number) => {
            return weeks[index1] + "：" + value.map((value, index2) => {
                return value === 0 ? -1 : index2
            }).filter(value => value != -1)
        }
    ).join(FULL_COMMA) + "]"
}

export const createUserLogItemListFromStringValue = (
    label: string,
    beforeValue: any | null,
    afterValue: any,
) => {
    const retObj: ItemList = {
        key: label,
        beforeValue: beforeValue ?? BLANK,
        afterValue: afterValue,
    }
    return retObj
}

export const createUserLogItemListByOption = (
  label: string,
  itemName: string,
  beforeInfo: any | null,
  afterInfo: any,
  options: Option[],
) => {
    const retObj: ItemList = {
        key: label,
        beforeValue: valueToOptionNull(beforeInfo?.[itemName], options)?.label ?? BLANK,
        afterValue: valueToOptionNull(afterInfo?.[itemName], options)?.label ?? BLANK,
    }
    return retObj
}

export const createUserLogItemListByOptionWithNull = (
    label: string,
    itemName: string,
    beforeInfo: any | null,
    afterInfo: any,
    options: any[],
  ) => {
      const retObj: ItemList = {
          key: label,
          beforeValue: valueToOptionNull(beforeInfo?.[itemName], options)?.label ?? BLANK,
          afterValue: valueToOptionNull(afterInfo?.[itemName], options)?.label ?? BLANK,
      }
      return retObj
  }

export const createUserLogItemListByOptionBool = (
  label: string,
  itemName: string,
  beforeInfo: any | null,
  afterInfo: any,
  options: OptionBool[],
) => {
    const retObj: ItemList = {
        key: label,
        beforeValue: valueToOptionNull(beforeInfo?.[itemName], options)?.label ?? BLANK,
        afterValue: valueToOptionNull(afterInfo?.[itemName], options)?.label ?? BLANK,
    }
    return retObj
}

export const createUserLogItemListFromArray = (
    label: string,
    itemName: string,
    beforeInfo: any | null,
    afterInfo: any,
) => {
    const retObj: ItemList = {
        key: label,
        beforeValue: beforeInfo?.[itemName]?.join(FULL_COMMA) ?? BLANK,
        afterValue: afterInfo?.[itemName]?.join(FULL_COMMA) ?? BLANK,
    }
    return retObj
}

export const createUserLogItemListFromArrayAddSB = (
  label: string,
  itemName: string,
  beforeInfo: any | null,
  afterInfo: any,
) => {
    let beforeValue = "";
    let afterValue = "";
    if(beforeInfo?.[itemName] && beforeInfo?.[itemName]?.length > 0) {
        beforeValue = `[${beforeInfo?.[itemName]?.join(FULL_COMMA) ?? BLANK}]`;
    }
    if(afterInfo?.[itemName] && afterInfo?.[itemName]?.length > 0) {
        afterValue = `[${afterInfo?.[itemName]?.join(FULL_COMMA) ?? BLANK}]`;
    }
    const retObj: ItemList = {
        key: label,
        beforeValue: beforeValue,
        afterValue: afterValue,
    }
    return retObj
}

export const createUserLogItemListFromArrayAddSB2 = (
    label: string,
    itemName: string,
    beforeInfo: any | null,
    afterInfo: any,
) => {
    let beforeValue = "";
    let afterValue = "";
    if(beforeInfo?.[itemName] && beforeInfo?.[itemName]?.length > 0) {
        beforeValue = `${beforeInfo?.[itemName]?.join("\n") ?? BLANK}`;
    }
    if(afterInfo?.[itemName] && afterInfo?.[itemName]?.length > 0) {
        afterValue = `${afterInfo?.[itemName]?.join("\n") ?? BLANK}`;
    }
    const retObj: ItemList = {
        key: label,
        beforeValue: beforeValue,
        afterValue: afterValue,
    }
    return retObj
}

export const createUserLogItemListFromObject = (
    label: string,
    itemName: string,
    beforeInfo: any | null,
    afterInfo: any,
) => {
    const retObj: ItemList = {
        key: label,
        beforeValue: beforeInfo?.[itemName] ? JSON.stringify(beforeInfo?.[itemName]) : BLANK,
        afterValue: afterInfo?.[itemName] ? JSON.stringify(afterInfo?.[itemName]) : BLANK,
    }
    return retObj
}

export const createUserLogItemListFromPictureFile = (
    label: string,
    index: number,
    beforeInfo: any | null,
    afterInfo: any,
    afterPictures: any,
) => {
    const retObj: ItemList = {
        key: label,
        beforeValue: beforeInfo?.imageName ?? BLANK,
        afterValue: (afterPictures?.[index]?.name ?? (afterInfo?.imageName !== BLANK ? beforeInfo?.imageName : BLANK)),
    }
    return retObj
}

// MS固有関数　

export const createUserLogItemListFromSugotokuMs = (
    label: string,
    itemName: string,
    beforeInfo: any | null,
    afterInfo: any,
) => {

    const retObj: ItemList = {
        key: label,
        beforeValue: beforeInfo ? beforeInfo?.[itemName][0] === 1 ? "チェックあり" : "チェックなし": BLANK,
        afterValue: afterInfo?.[itemName][0] === 1 ? "チェックあり" : "チェックなし"
    }
    return retObj
}

export const createUserLogItemListFromAgeMs = (
    label: string,
    itemName: string,
    beforeInfo: any | null,
    afterInfo: any,
) => {
    const retObj: ItemList = {
        key: label,
        beforeValue: beforeInfo?.[itemName]?.length !== 0 && beforeInfo ?  "[" + (beforeInfo?.[itemName]?.join(FULL_COMMA) ?? BLANK) + "]" : BLANK,
        afterValue: afterInfo?.[itemName]?.length !== 0 && afterInfo ? "[" + (afterInfo?.[itemName]?.join(FULL_COMMA) ?? BLANK) + "]" : BLANK,
    }
    return retObj
}

export const createUserLogItemListFromGenderMs = (
    label: string,
    itemName: string,
    beforeInfo: any | null,
    afterInfo: any,
) => {

    const ageLabels = [BLANK, "男性", "女性", "不明"]

    const retObj: ItemList = {
        key: label,
        beforeValue: beforeInfo?.[itemName]?.length !== 0 && beforeInfo ? "[" + (beforeInfo?.[itemName].map((value: number) => {
            return ageLabels[value]
        })?.join(FULL_COMMA) ?? BLANK)+ "]" : BLANK,
        afterValue: afterInfo?.[itemName]?.length !== 0 && afterInfo ? "[" + (afterInfo?.[itemName].map((value: number) => {
            return ageLabels[value]
        })?.join(FULL_COMMA) ?? BLANK) + "]" : BLANK,
    }
    return retObj
}

export const createUserLogItemListFromPrefectureMs = (
    label: string,
    itemName: string,
    beforeInfo: any | null,
    afterInfo: any,
) => {

    const prefecterLabels = [BLANK].concat(options_pref.map((value: any) => value.label))

    const retObj: ItemList = {
        key: label,
        beforeValue: beforeInfo?.[itemName]?.length !== 0 && beforeInfo ? "[" + (beforeInfo?.[itemName].map((value: number) => {
            return prefecterLabels[value]
        })?.join(FULL_COMMA) ?? BLANK) + "]" : BLANK,
        afterValue: afterInfo?.[itemName]?.length !== 0 && afterInfo ? "[" + (afterInfo?.[itemName].map((value: number) => {
            return prefecterLabels[value]
        })?.join(FULL_COMMA) ?? BLANK) + "]" : BLANK
    }
    return retObj
}

const extractTrackingLabels = (
    items: any,
    option: any,
) => {
    return items?.map((value: any) => {
        const targetElem = option.filter((value1: any) => {
            return value.trackingPointId === value1.value
        })
        return targetElem?.map((value1: any) => `${value1.label}`)
    })
}

const extractAfinityLabels = (
    items: any,
    option: any,
) => {
    return items?.map((value: any) => {
        const targetElem = option.filter((value1: any) => {
            return value === value1.value
        })
        return targetElem?.map((value1: any) => `${value1.label}`)
    })
}

const extractNormalLabel = (
    value: any,
    option: any,
) => {
    return value ? option.filter((elem: any) => value === elem.value )
        ?.map((elem: any) => `${elem.label}`)?.[0]
        : BLANK
}

export const createUserLogItemListFromOptionValuesTrackingMs = (
    label: string,
    itemName: string,
    beforeInfo: any | null,
    afterInfo: any,
    option: any,
) => {
    const beforeValueLabel = extractTrackingLabels(beforeInfo?.[itemName], option)
    const afterValueLabel = extractTrackingLabels(afterInfo?.[itemName], option)

    const retObj: ItemList = {
        key: label,
        beforeValue: beforeInfo?.[itemName]?.length !== 0 && beforeValueLabel ? "[" + beforeValueLabel?.join(FULL_COMMA) + "]" : BLANK,
        afterValue: afterInfo?.[itemName]?.length !== 0 && afterValueLabel ? "[" + afterValueLabel?.join(FULL_COMMA) + "]" : BLANK,
    }
    return retObj
}

export const createUserLogItemListFromOptionValuesAfinitysMs= (
    label: string,
    itemName: string,
    beforeInfo: any | null,
    afterInfo: any,
    option: any,
) => {
    const beforeValueLabel = extractAfinityLabels(beforeInfo?.[itemName], option)
    const afterValueLabel = extractAfinityLabels(afterInfo?.[itemName], option)

    const retObj: ItemList = {
        key: label,
        beforeValue: beforeInfo?.[itemName]?.length !== 0 && beforeInfo ? "[" + beforeValueLabel?.join(FULL_COMMA) + "]" : BLANK,
        afterValue: afterInfo?.[itemName]?.length !== 0 && afterInfo ? "[" + afterValueLabel?.join(FULL_COMMA) + "]" : BLANK,
    }
    return retObj
}

export const createUserLogItemListFromOptionValuesNormalListMs = (
    label: string,
    itemName: string,
    beforeInfo: any | null,
    afterInfo: any,
    option: any,
) => {
    const beforeValueLabel = extractNormalLabel(beforeInfo?.[itemName], option)
    const afterValueLabel = extractNormalLabel(afterInfo?.[itemName], option)

    const retObj: ItemList = {
        key: label,
        beforeValue: beforeValueLabel,
        afterValue: afterValueLabel,
    }
    return retObj
}

export const handleSuccessEventLog = (executeLogData: LogData) => {
    executeLogData.eventDate = moment().format("YYYY-MM-DD HH:mm:ss");
    executeLogData.logType = "result";
    executeLogData.result = "成功";
    ApolloEventRecord(executeLogData);
}

export const handleFailureEventLog = (executeLogData: LogData) => {
    executeLogData.eventDate = moment().format("YYYY-MM-DD HH:mm:ss");
    executeLogData.logType = "result";
    executeLogData.result = "失敗";
    ApolloEventRecord(executeLogData);
}